<template>
    <div>
        <md-button
            title="Add Stop"
            class="md-primary md-just-icon md-round pull-right header-button"
            :class="$root.isMobileOnly ? 'smaller-button' : ''"
            @click="() => createStop(true)"
            :disabled="isCustomer"
        >
            <md-icon>add</md-icon>
        </md-button>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { STOP_DETAILS_DEFAULTS } from '@/utils/defaults';
import { mapGetters } from 'vuex';
import { CustomerMixin } from '@/mixins/CustomerMixin';
import CreateStopModal from './CreateStopModal';

export default {
    name: 'CreateStop',
    mixins: [GeneralMixin, CustomerMixin],
    props: {
        teamMembers: {
            type: Array,
            default: () => []
        },
        selectedMemberId: {
            type: [String, Number],
            default: () => 0
        },
        displayAvailabilityIndicator: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            isCustomerAdmin: 'user/isCustomerAdmin',
            isCustomer: 'user/isCustomer'
        })
    },
    data() {
        return {
            stopDetails: Object.assign({}, STOP_DETAILS_DEFAULTS())
        };
    },
    methods: {
        async handleCreateCustomer(currentStopDetails) {
            this.stopDetails = {
                ...this.stopDetails,
                ...currentStopDetails,
                ...(await this.$_customerMixin_createCustomer(this.user.teamRegionId || null))
            };

            this.selectedMemberId = currentStopDetails.assignToPublicUserId;
            this.createStop(false);
        },
        createStop(resetState = true) {
            if (resetState) {
                this.resetStopState();
            }

            if (this.selectedMemberId !== null) {
                this.stopDetails.assignToPublicUserId = this.selectedMemberId;
            }
            if (this.isCustomerAdmin) {
                this.stopDetails.customerId = this.user.customerId || null;
            }

            // User user or team default stop duration, if null use value from STOP_DETAILS_DEFAULTS
            this.stopDetails.durationMinutes = this.user.defaultStopDurationMinutes ?? this.stopDetails.durationMinutes;

            this.$modal
                .show(CreateStopModal, {
                    members: this.teamMembers,
                    stopDetails: this.stopDetails,
                    createCustomer: this.handleCreateCustomer,
                    displayAvailabilityIndicator: this.displayAvailabilityIndicator
                })
                .then((response) => {
                    if (response && response.toLowerCase() === 'ok') {
                        this.emitStopCreated();
                        this.$modal.hide();
                    }
                });
        },
        emitStopCreated() {
            this.resetStopState();
            this.$emit('stopCreated');
        },
        resetStopState() {
            this.stopDetails = { ...STOP_DETAILS_DEFAULTS() };
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-btn {
    margin-right: 16px;
}
.smaller-button {
    width: 30px; /* Adjust width */
    height: 30px; /* Adjust height */
    min-width: 30px;
    padding: 4px;
    font-size: 12px;
    margin: 0;
}
</style>
